// src/pages/LandingPage.js
import React, {useState} from 'react';
import {
    SparklesIcon,
    ChartBarIcon,
    UsersIcon,
    CheckCircleIcon,
    CurrencyDollarIcon,
    CreditCardIcon,
    XMarkIcon
} from '@heroicons/react/24/outline';
import {Bars3Icon} from "@heroicons/react/16/solid";

// This is the main Landing Page component for LocalRewards
const TestOnePage = ({ navigateTo }) => {

    return (
        <></>
    );
};

export default TestOnePage;